export default "__VITE_ASSET__N4FJCAHj_LUP1U7r6y$b$w__"